export const setVersion =
  (version: number) =>
  <T>(sectionsResponse: T) => ({
    ...sectionsResponse,
    version,
  });
